<script>
export default {
  name: 'ToppingsModal',
  components: {},
  props: {
    product: {
      type: Object,
      required: true,
    },
    toppingsUpdate: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      selectedToppings: [],
    }
  },
  created() {},
  methods: {
    handleToppings(toppings) {
      this.toppingsUpdate(toppings)
      this.$emit('close')
    },
  },
}
</script>

<template>
  <div class="toppings-modal">
    <h4 align="left">¿Qué elemento hace falta?</h4>
    <p-check
      v-for="(t,i) in product.toppings"
      :key="i"
      :label="t.value"
      :id="t.value"
      :value="t"
      v-model="selectedToppings"
      class="p-icon p-curve p-smooth checkbox-d"
      color="success"
    >
      <i
        slot="extra"
        class="icon material-icons checkbox-d__i">done</i>
      <div class="checkbox-d__text-label">
        {{ t.value || t.description || t }}
      </div>
    </p-check>

    <div class="toppings-modal__buttons-container">
      <v-btn
        class="toppings-modal__button"
        depressed
        flat
        @click="handleToppings([])">Ninguno</v-btn>
      <v-btn
        class="toppings-modal__button"
        depressed
        flat
        @click="handleToppings(selectedToppings)">Enviar</v-btn>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.toppings-modal {
  display: flex;
  flex-flow: column wrap;
  padding: 1.5rem;

  &__button {
    width: 20%;
    margin-right: -10px;
    color: $primary-green;
  }

  &__buttons-container {
    display: flex;
    flex-flow: row wrap;
    justify-content: flex-end;
  }
}

h4 {
  align-self: flex-start;
  width: 100%;
  margin-bottom: 2rem;
  font-weight: bold;
  color: $charcoal-gray;

  @extend %typography-large;
}

.checkbox-d {
  margin-bottom: 2rem;

  &__text-label {
    margin-left: 2rem;
  }

  &__i {
    background-color: $primary-green;
    border-radius: 2px;
  }
}
</style>
